export const environment = {
  production: true,
  //databaseID: 5, // psp
  //databaseID: 8, // capital lake
  //databaseID: 14, // oakland
  //databaseID: 17, // wind
  //databaseID: 25, // cpuc
  //databaseID: 36, // duck2
  databaseID: 1, // comment-tracker
  api: "https://api.comment-tracker.esassoc.com/api/",
  //projectID: 1, // psp
  //projectID: 2, // capital lake
  //projectID: 4, // oakland
  //projectID: 5, // wind
  //projectID: 7, // cpuc
  //projectID: 8, // duck
  //projectID: 10, // seattle center
  //projectID: 11, //duck2
  //projectID: 12, //demo
  //projectID: 16, // Medford Airport
  //projectID: 17, // FAA Boston
  //projectID: 19, // 8miledam
  //projectID: 21, // clde
  //projectID: 22, // silverlake
  // projectID: 25,
  // theme: "tacoma",
  // langs: ['en',  'zh', 'sp', 'va'], // ['en', 'fr', 'ceb', 'zh', 'fil', 'hmn', 'ja', 'kh', 'ko', 'mo', 'sp', 'va']
  // serverUrl: "http://comment-tracker.esassoc.com/tacoma"
  // projectID: 26,
  // theme: "bellevue",
  // langs: ["en", "ja", "ko", "ru", "sp", "va", "zh", "zh-Hant"],
  // serverUrl: "http://comment-tracker.esassoc.com/bellevue",
  projectID: 33,
  theme: "seapart150",
  langs: ['en', 'sp', 'va', 'zh', 'ko', 'am', 'so' ],
  serverUrl: "http://comment-tracker.esassoc.com/seapart150",
  bonusUrl: "https://www.seapart150.com",
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts